import { render, staticRenderFns } from "./level-stat.vue?vue&type=template&id=3a80ff46&scoped=true&"
import script from "./level-stat.vue?vue&type=script&lang=js&"
export * from "./level-stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a80ff46",
  null
  
)

export default component.exports